/**
 * DNDIndicator Component
 * Header indicator showing Do Not Disturb status with quick disable
 */

import { useDND } from '../../hooks/useDND';

export const DNDIndicator = () => {
  const { status, disable, isDisabling } = useDND();

  if (!status?.enabled) {
    return null;
  }

  const getTimeRemaining = (): string => {
    if (!status.mutedUntil) return '';

    if (status.isIndefinite) {
      return 'безкрайно';
    }

    const now = new Date();
    const until = new Date(status.mutedUntil);
    const diffMs = until.getTime() - now.getTime();
    const diffMinutes = Math.floor(diffMs / 60000);

    if (diffMinutes < 60) {
      return `${diffMinutes} мин`;
    }

    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;

    if (minutes === 0) {
      return `${hours} ч`;
    }

    return `${hours}ч ${minutes}мин`;
  };

  return (
    <div className="group relative">
      <button
        onClick={() => !isDisabling && disable()}
        disabled={isDisabling}
        className={`
          flex items-center space-x-2 px-3 py-1.5 rounded-lg
          bg-purple-100 dark:bg-purple-900/30
          hover:bg-purple-200 dark:hover:bg-purple-900/50
          transition-colors
          ${isDisabling ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        `}
        aria-label="Не безпокойте активен - кликнете за изключване"
      >
        <svg
          className="w-4 h-4 text-purple-700 dark:text-purple-300"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zm0 16a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
          <line x1="3" y1="3" x2="17" y2="17" stroke="currentColor" strokeWidth="2" />
        </svg>
        <span className="text-xs font-medium text-purple-700 dark:text-purple-300">
          {status.isIndefinite ? 'Не безпокойте' : getTimeRemaining()}
        </span>
      </button>

      {/* Tooltip */}
      <div
        className="
          absolute right-0 top-full mt-2 w-48 p-3
          bg-gray-900 dark:bg-gray-700 text-white text-xs rounded-lg shadow-lg
          opacity-0 invisible group-hover:opacity-100 group-hover:visible
          transition-all duration-200 z-50
        "
      >
        <p className="font-medium mb-1">Не безпокойте активен</p>
        <p className="text-gray-300 dark:text-gray-400 mb-2">
          {status.isIndefinite
            ? 'Активен безкрайно'
            : `Остават ${getTimeRemaining()}`}
        </p>
        <p className="text-gray-400 dark:text-gray-500">
          Кликнете за изключване
        </p>
        <div className="absolute -top-1 right-4 w-2 h-2 bg-gray-900 dark:bg-gray-700 transform rotate-45" />
      </div>
    </div>
  );
};
